import React, { useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/solid';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import styles from '../../styles/carousel.module.css';
import StartTrackingButton from './StartTrackingButton';
import useMediaQuery from '../../hooks/useMediaQuery';


const Features = ({ features, showCheckoutPopup, mediaUrl }) => {
    const [swiper, setSwiper] = useState(null);
    const isAboveMediumScreens = useMediaQuery("(min-width: 1026px)");

    return (
        <section className={styles.mainSection}>
            <div className={styles.maxWidth}>
                <Swiper
                    modules={[Navigation]}
                    spaceBetween={30}
                    slidesPerView={1}
                    onSwiper={setSwiper}
                    className={styles.swiperStyle}
                >
                    {features.map(({ id, title, content, imgName, link, linkContent, partContent }) => (
                        <SwiperSlide key={id}>
                            <div key={id}
                                className={styles.featureCarouselContainer}
                            >
                                <div className={styles.featureImageContainer}>
                                    <img src={isAboveMediumScreens ? require(`../../assets/carouselImages/${imgName}_desk.webp`) : require(`../../assets/carouselImages/${imgName}_mobile.webp`)} alt="carousel_image" />
                                </div>
                                <div className={styles.featureTextContainer}>
                                    <p className={styles.featureTitle}>{title}</p>
                                    <p className={styles.featureContent}>{partContent}{link ? <a href={link}>{linkContent}</a> : null}{content}</p>
                                </div>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>

                <div className={styles.featuresNavigationContainer}>
                    <button
                        onClick={() => swiper?.slidePrev()}
                        className={styles.featureNavLeftButton}
                    >
                        <ChevronLeftIcon className={styles.featuresNavLeftIcon} />
                    </button>
                    <button
                        onClick={() => swiper?.slideNext()}
                        className={styles.featureNavRightButton}
                    >
                        <ChevronRightIcon className={styles.featuresNavIcon} />
                    </button>
                </div>
            </div>
            <div className={styles.buttonContainer}>
                <StartTrackingButton title="Start Tracking Now" style={styles.startTrackingButton} onButtonClick={showCheckoutPopup} />
            </div>
        </section>
    );
}

export default Features;